/**
 * When true, `returnTo` should not override membership-based post-login routing
 * (single-org shortcut, `/organizations`). Handles `/`, `/callback`, and same-origin
 * absolute URLs whose path is `/` or `/callback` (e.g. AuthGuard previously sent
 * `window.location.toString()` for `/`).
 */
export function isMembershipDefaultReturnTo(returnTo: string): boolean {
  if (returnTo === '/' || returnTo === '/callback') {
    return true;
  }

  try {
    const parsed = new URL(returnTo, window.location.origin);

    if (parsed.origin !== window.location.origin) {
      return false;
    }

    const path = parsed.pathname || '/';

    return path === '/' || path === '' || path === '/callback';
  } catch {
    return false;
  }
}
